import { Component, HostBinding, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { pageTransitions } from '../../../animations/page-transitions';
import { User } from '../../../models/user';
import { UserService } from '../../../services/user.service';
import { DownloadImageService } from '../../../services/download-image.service';

@Component({
	selector: 'copo-legal-privacy-policy',
	templateUrl: './legal-privacy-policy.component.html',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [MatExpansionModule, TranslateModule]
})
export class LegalPrivacyPolicyComponent implements OnInit, OnDestroy {
	@HostBinding('class.passthrough') componentClass = true;
	subscription: Subscription | undefined;
	user: User;

	constructor(
		private readonly downloadImageService: DownloadImageService,
		private readonly userService: UserService,
		private readonly route: ActivatedRoute,
	) {
		this.user = this.userService.user;
	}

	ngOnInit(): void {
		this.subscription = this.route.fragment.subscribe(fragment => {
			if (fragment) {
				this.scrollToFragment(fragment);
			}
		});
	}

	ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}

	scrollToFragment(fragment: string) {
		try {
			setTimeout(() => {
				const panel = document.querySelector(`#${ fragment }`);
				if (panel) {
					panel.scrollIntoView({ behavior: 'instant', block: 'center' });
				}
			}, 100);
		} catch (error) {
			console.error('Error scrolling into fragmnent', error);
		}
	}

	async downloadImage(imageName: string) {
		const blobImg = await this.downloadImageService.downloadImage(imageName);
		if (!(blobImg instanceof HttpErrorResponse)) {
			open(blobImg, '_blank');
		}
	}
}
